import {Route, Routes} from "react-router-dom";

//Страница №1
import GreetingsPage from './Pages/GreetingsPage';
//Страница №2
import ViewPage from './Pages/ViewPage';
//Страница №3
import GetEsiaData from './Pages/GetEsiaData';
//Страница №4
import DocumentsPage from './Pages/DocumentsPage';
// Страница №5
import SignProcessPage from './Pages/SignProcessPage';
//Страница №6
import SignedDocPage from './Pages/SignedDocPage';

//Страница предварительного просмотра
import OneDoc from './Pages/OneDoc';
//Страница оплаты (Совершить оплату)
import FormPayAnyWay from "./payments/formPayAnyWay";
//Страница 404
import NotFoundPage from "./Pages/NotFoundPage";
//Страница ошибок
import ErrorPage from "./Pages/ErrorPage";

//? Непонятно что
import PdfViewer from './PdfViewer';

//Стили
import './App.css';


function App() {
    return (
        <Routes>
            {/** Страница №1 */}
            <Route path='/' element={<GreetingsPage/>}/>

            {/*<Route path='/s/:id' element={<GreetingsPage/>}/>*/}
            {/*<Route path='/m/:id' element={<GreetingsPage/>}/>*/}
            {/*<Route path='/p/:id' element={<GreetingsPage/>}/>*/}
            {/*<Route path='/t/:id' element={<GreetingsPage/>}/>*/}

            {/*<Route path='/:prefix/:id' element={<GreetingsPage/>}/>*/}
            {/*<Route path='/:any*' element={<GreetingsPage/>} />*/}

            {/** Страница №2 */}
            <Route path='/view' element={<ViewPage/>}/>
            {/** Страница №3 */}
            <Route path='/esia' element={<GetEsiaData/>}/>
            {/** Страница №4 */}
            <Route path='/doc' element={<DocumentsPage/>}/>
            {/** Страница №5 */}
            <Route path='/signdocs' element={<SignProcessPage/>}/>
            {/** Страница №6 */}
            <Route path='/signed' element={<SignedDocPage/>}/>

            {/** Страница предварительного просмотра */}
            <Route path='/doc/:id' element={<OneDoc/>}/>
            {/** Страница оплаты (Совершить оплату) */}
            <Route path='/payments' element={<FormPayAnyWay/>}/>

            {/** Непонятно что */}
            <Route path='/pdf' element={<PdfViewer/>}/>

            {/** Страница ошибок */}
            <Route path='/error' element={<ErrorPage/>} />

            {/** Страница №1 */}
            <Route path='/:prefix/*' element={<GreetingsPage/>}/>

            {/** Страница 404 */}
            <Route path='*' element={<NotFoundPage/>}/>


            {/*<Route path='*' element={<GreetingsPage/>}/>*/}

        </Routes>
    );
}

export default App;
